import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";

import {showToastForBackend, showToastForFrontend} from "../../../../../actions/toastActions";
import ContextPropertyModifierSubQuery from "./components/ContextPropertyModifierSubQuery";
import ContextPropertyModifierValue from "./components/ContextPropertyModifierValue";
import possibleFunctions from '../../possibleFunctions';
import {FunctionModifier} from "../../InputPortListUtils/components/FunctionModifier";
import {AddNewOptionsButtonGroup} from "../../InputPortListUtils/components/AddNewOptionsButtonGroup";
import axios from "axios";
import axiosConfig from "../../../../../utils/axiosConfig";
import messageCodes from "../../../../../utils/messageCodes";

export const ContextPropertyModifier = (props) => {
    const {modifier, properties} = props;
    const [state, setState] = useState({
        func: modifier,
        userProperties: props.userProperties ? props.userProperties : [],
        itemProperties: props.itemProperties ? props.itemProperties : [],
    });

    const funcArgs = state?.func?.funcArgs;

    const isGroup = (argument) => {
        return Object.keys(possibleFunctions).includes(argument.funcName);
    }

    const getItemProperties =  () => {
        const itemProperties = state.itemProperties;

        if (itemProperties.length === 0) {
            axios.get(props.properties.databaseUrl + "/properties/items", axiosConfig())
                .then(response => {
                    setState({
                        ...state,
                        itemProperties: response.data
                    });
                })
                .catch(err => {
                    if (err.response)
                        props.showToastForBackend(err.response.data);
                    else
                        props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                });
        }
    }

    useEffect(() => {
        if (properties) {
            getItemProperties();
        }
    }, [properties]);

    useEffect(() => {
        props.updateOptions(state.func)
    }, [state.func])

    const onArgumentOptionUpdate = (index, argumentData) => {
        let fieldModifier = {...state.func};
        fieldModifier.funcArgs[index] = argumentData;

        setState(prevState => {
            return {
                ...state,
                func: {
                    ...fieldModifier
                }
            }
        });
    }

    const onArgumentDelete = (index) => {
        setState(prevState => {
            const updatedFunc = { ...prevState.func };
            updatedFunc.funcArgs = updatedFunc.funcArgs.filter((value, funcArgIndex) => funcArgIndex !== index);
            return { ...prevState, func: updatedFunc };
        });
    }

    const handleToggleModifier = (modifierFunctionKey) => {
        const funcName = modifierFunctionKey;
        setState(prevState => ({
                ...prevState,
                func: {
                    ...prevState.func,
                    funcName
                }
            }
        ))
    }

    return (
        <div className="field-modifier-group">
            <div className="field-modifier-group-content">
                <div className="predicate-panel field-modifier-panel">
                    <div className="predicate-group-header-wrapper field-modifier-header">
                        <FunctionModifier state={state} handleToggleModifier={handleToggleModifier}/>
                        <div className="main-and predicate-group and">
                            {state?.func?.funcArgs?.map((argument, index) => {
                                if (isGroup(argument)) {
                                    return (
                                        <ContextPropertyModifierSubQuery
                                            key={argument?.noneOptions?.dataValue}
                                            disableArea={props.disableArea}
                                            defaultPredicateValue={props.defaultPredicateValue}
                                            userProperties={state.userProperties}
                                            itemProperties={state.itemProperties}
                                            contextProperties={props.contextProps}
                                            predicateBlockType={props.predicateBlockType}
                                            argument={argument}
                                            onArgumentOptionUpdate={(data => onArgumentOptionUpdate(index, data))}
                                            onArgumentDelete={() => onArgumentDelete(index)}
                                            elementIdAutoIncrement={modifier.elementIdAutoIncrement}
                                            updateProperty={props.updateProperty}
                                            possibleFunctions={possibleFunctions}
                                        />
                                    )
                                } else {
                                    return <ContextPropertyModifierValue
                                        key={argument?.noneOptions?.dataValue}
                                        disableArea={props.disableArea}
                                        {...argument}
                                        userProperties={state.userProperties}
                                        itemProperties={state.itemProperties}
                                        contextProperties={props.contextProps}
                                        predicateBlockType={props.predicateBlockType}
                                        onArgumentOptionUpdate={(data) => onArgumentOptionUpdate(index, data)}
                                        onArgumentDelete={() => onArgumentDelete(index)}
                                    />
                                }
                            })}
                        </div>
                        <AddNewOptionsButtonGroup state={state}
                                                  setState={setState}
                                                  updateOptions={props.updateOptions}
                                                  updateProperty={props.updateProperty}
                                                  elementIdAutoIncremen={modifier.elementIdAutoIncrement}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        func: state.func,
        properties: state.properties,
        contextProps: state.contextProperties,
        userProperties: state.userProperties
    }
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(ContextPropertyModifier);